import { render, staticRenderFns } from "./CustomChat.vue?vue&type=template&id=410684b7"
import script from "./CustomChat.vue?vue&type=script&lang=js"
export * from "./CustomChat.vue?vue&type=script&lang=js"
import style0 from "./style.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports